import { skipToken, useQuery } from '@tanstack/react-query';

import { getOpportunityFieldHistory } from '~/services/ContractingService';

import type {
  ContractingDealFieldHistoryEntityType,
  ContractingFieldHistoryParams,
} from '~/types/services/contracting';

import { fieldHistoryQueryKeys } from './fieldHistoryQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetOpportunityFieldHistory(
  salesforceOpportunityId: string | undefined,
  entityType: ContractingDealFieldHistoryEntityType | undefined,
  params: ContractingFieldHistoryParams,
) {
  return useQuery({
    queryKey: fieldHistoryQueryKeys.opportunity(salesforceOpportunityId ?? '', entityType, params),
    queryFn:
      salesforceOpportunityId && entityType
        ? ({ signal }) => getOpportunityFieldHistory(salesforceOpportunityId, entityType, params, { signal })
        : skipToken,
    retry: retryUnlessRejected,
  });
}
